import CartService from "@/services/CartService";

const state = {
  items: [],
  isLoading: false,
  discount: 0,
  shippingCost: 0, // This can be used to store shipping cost if needed
};

const mutations = {
  SET_ITEMS(state, items) {
    state.items = JSON.parse(JSON.stringify(items || []));
  },
  SET_LOADING(state, isLoading) {
    state.isLoading = isLoading;
  },
  SET_DISCOUNT(state, discount) {
    state.discount = discount;
  },
  SET_SHIIPING_COST(state, shippingCost) {
    state.shippingCost = shippingCost;
  },
};

const actions = {
  async fetchCart({ commit }) {
    commit("SET_LOADING", true);
    try {
      const response = await CartService.getCart();
      commit("SET_ITEMS", response?.data?.data?.data || []);
    } finally {
      commit("SET_LOADING", false);
    }
  },

  async addToCart({ commit, dispatch }, product) {
    commit("SET_LOADING", true);
    try {
      await CartService.addToCart({
        product_id: product.id,
        quantity: 1,
        size_id: product.size_id,
        color_id: product.color_id,
        share_id: product.share_id,
      }).then((response) => {
        if (!response.data.status.error) {
          dispatch("alert/success", response.data.status.message, {
            root: true,
          });
        }
      });
      await dispatch("fetchCart");
    } finally {
      commit("SET_LOADING", false);
    }
  },

  addShippingCost({ commit }, shippingCost) {
    // This action is not used in the current implementation
    // but can be used to set shipping cost if needed in the future
    commit("SET_SHIIPING_COST", shippingCost);
  },

  async updateCart({ commit, dispatch }, items) {
    commit("SET_LOADING", true);
    try {
      await CartService.updateCart(items).then((response) => {
        if (!response.data.status.error) {
          dispatch("alert/success", response.data.status.message, {
            root: true,
          });
        }
      });
      await dispatch("fetchCart");
    } finally {
      commit("SET_LOADING", false);
    }
  },

  async updateQuantity({ commit, dispatch }, { item, quantity }) {
    commit("SET_LOADING", true);
    try {
      // Find the item in the cart
      const items = [...state.items];
      const itemIndex = items.findIndex((i) => i.id === item.id);

      if (itemIndex !== -1) {
        // Update the quantity
        items[itemIndex] = {
          ...items[itemIndex],
          quantity: quantity, // Ensure quantity is between 1 and 100
        };

        // Call updateCart with the modified items
        await dispatch("updateCart", items);
      }
    } finally {
      commit("SET_LOADING", false);
    }
  },

  async removeItem({ commit, dispatch }, { id }) {
    commit("SET_LOADING", true);
    try {
      await CartService.removeItem(id).then((response) => {
        if (!response.data.status.error) {
          dispatch("alert/success", response.data.status.message, {
            root: true,
          });
        }
      });
      await dispatch("fetchCart");
    } finally {
      commit("SET_LOADING", false);
    }
  },

  async clearCart({ commit, dispatch }) {
    commit("SET_LOADING", true);
    try {
      await CartService.clearCart().then((response) => {
        if (!response.data.status.error) {
          dispatch("alert/success", response.data.status.message, {
            root: true,
          });
        }
      });
      await dispatch("fetchCart");
    } finally {
      commit("SET_LOADING", false);
    }
  },

  async applyCoupon({ commit, dispatch }, discount) {
    commit("SET_LOADING", true);
    try {
      commit("SET_DISCOUNT", discount);
    } finally {
      commit("SET_LOADING", false);
    }
  },
};

const getters = {
  cartItems: (state) => state.items,
  cartSubTotal: (state) =>
    state.items.reduce((total, item) => total + item.price * item.quantity, 0),
  cartTotal: (state) =>
    state.items.reduce((total, item) => total + item.price * item.quantity, 0) -
    parseInt(state.discount) +
    parseInt(state.shippingCost),

  cartCount: (state) =>
    state.items.reduce((count, item) => count + item.quantity, 0),
  isLoading: (state) => state.isLoading,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
